import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

/** テナント設定APIKeyのビューモデル */
export type TenantSettingApikeyViewModel = {
  /** すでにAPI Keyを持っているか */
  hasApikey: boolean;
  /** clientId */
  clientId: string;
  /** クライアントシークレットの値 */
  clientSecretValue: string;
};

@Component({
  selector: 'app-tenant-setting-apikey-edit-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatIconModule,
    CommonModule,
  ],
  templateUrl: './tenant-setting-apikey-edit-dialog.component.html',
  styleUrl: './tenant-setting-apikey-edit-dialog.component.scss',
})
export class TenantSettingApikeyEditDialogComponent {
  public apikey: TenantSettingApikeyViewModel;

  constructor(
    @Inject(MAT_DIALOG_DATA) options: TenantSettingApikeyViewModel,
    private dialogRef: MatDialogRef<TenantSettingApikeyEditDialogComponent>,
    private dialog: MatDialog,
  ) {
    this.apikey = options;
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public copyClientId(): void {
    navigator.clipboard.writeText(this.apikey.clientId);
  }

  public copyClientSecret(): void {
    navigator.clipboard.writeText(this.apikey.clientSecretValue);
  }
}
